import { Action } from '@ngrx/store';
import {
    AUTH_DELETE,
    AUTH_COMPANY_SET,
    AUTH_USER_SET,
    PASSWORD_REQUEST_VERIFICATION_CODE,
    PASSWORD_SUBMIT_VERIFICATION_CODE,
    PASSWORD_RESET
} from '../action-types';
import { AuthSession } from '@core/models/auth/auth-session';
import { ObservableAction } from '../shared/actions/observable-action';

export class SetUserAuthAction implements Action {
    readonly type = AUTH_USER_SET;

    constructor(public payload: AuthSession) {}
}

export class SetCompanyAuthAction implements Action {
    readonly type = AUTH_COMPANY_SET;

    constructor(public payload: AuthSession) {}
}

export class DeleteAuthAction implements Action {
    readonly type = AUTH_DELETE;
}

export class RefreshTokenAction implements Action {
    readonly type = 'REFRESH_TOKEN';
}
export class InvalidateAccessTokenAction implements Action {
    readonly type = 'INVALIDATE_ACCESS_TOKEN';

    constructor(public payload?: { isUser?: boolean }) {}
}

export class InvalidateRefreshTokenAction implements Action {
    readonly type = 'INVALIDATE_REFRESH_TOKEN';

    constructor(public payload?: { isUser?: boolean }) {}
}

@ObservableAction()
export class RequestVerificationCodeAction implements Action {
    readonly type = PASSWORD_REQUEST_VERIFICATION_CODE;

    constructor(public payload: {
        phone?: string,
        email?: string
    }) {}
}

@ObservableAction()
export class SubmitVerificationCodeAction implements Action {
    readonly type = PASSWORD_SUBMIT_VERIFICATION_CODE;

    constructor(public payload: {
        code: string,
        id: string
    }) {}
}

@ObservableAction()
export class ResetPasswordAction implements Action {
    readonly type = PASSWORD_RESET;

    constructor(public payload: {
        password: string,
        id: string,
        code: string
    }) {}
}